<template>
  <div>

    <div class="ui huge menu">
      <a href="#" class="item" @click.prevent="triggerMenu">
        <i class="content icon"></i>
      </a>
      <div class="right menu"></div>
      <a href="#" class="red item" @click.prevent="addUser"><i class="plus icon"></i> Add User</a>
    </div>
    <div class="ui container">
      <h3 class="ui header">
        Users
      </h3>

      <div class="ui loader" :class="{ 'active': fetching }"></div>

      <table class="ui table">
        <thead>
        <tr>
          <th>
            Name
          </th>
          <th>
            Email
          </th>
          <th>
            Role
          </th>
          <th class="collapsing">
            Actions
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="user in users">
          <td>{{ user.name }}</td>
          <td>{{ user.email }}</td>
          <td>
            <div class="ui label" :class="[ {
                'red': user.role === 'superAdmin',
                'orange': user.role === 'admin',
                'blue': user.role === 'cashier',
                'green': user.role === 'crew'
              } ]">{{ user.role }}
            </div>
          </td>
          <td class="collapsing">
            <div class="ui tiny buttons">
              <div class="ui button" @click="editUser(user)"><i class="edit icon"></i> Edit User</div>
              <div class="ui floating dropdown blue icon button" @click.stop="">
                <i class="dropdown icon"></i>
                <div class="menu">
                  <div class="item" @click="editUser(user)"><i class="edit icon"></i> Edit User</div>
                  <div class="item" @click="triggerDeleteUser(user)"><i class="trash icon"></i> Delete User</div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>


    </div>

    <div class="ui small basic delete modal">
      <div class="header" style="text-align: center">
        Are you sure?
      </div>
      <div class="content" style="text-align: center">
        Delete user <strong v-if="userForDelete">{{ userForDelete.name }}</strong>
      </div>
      <div class="actions" style="text-align: center">
        <div class="ui red basic cancel inverted button">
          <i class="remove icon"></i>
          No
        </div>
        <div class="ui green ok inverted button" @click="deleteUser(userForDelete)">
          <i class="checkmark icon"></i>
          Yes
        </div>
      </div>
    </div>

    <div class="ui small modal" id="userModal">
      <i class="close icon"></i>
      <div class="header">
        <span v-if="user._id">Edit User</span>
        <span v-else>Add User</span>
      </div>
      <div class="content">
        <form class="ui form" @submit.prevent>
          <div class="ui field">
            <label>Email</label>
            <input class="ui input" v-model="user.email">
          </div>
          <div class="ui field">
            <label>Password</label>
            <input class="ui input" type="password" v-model="user.password">
          </div>
          <div class="ui field">
            <label>Name</label>
            <input class="ui input" type="text" v-model="user.name">
          </div>
          <div class="ui field">
            <label>Role</label>
            <select class="ui selection dropdown" v-model="user.role">
              <option value="">Select User Role...</option>
              <option value="crew">Crew</option>
              <option value="cashier">Cashier</option>
              <option value="sales">Sales</option>
              <option value="driver">Driver</option>
              <option value="admin">Admin</option>
              <option value="superAdmin">Super Admin</option>
            </select>
          </div>
        </form>
      </div>
      <div class="actions">
        <div class="ui icon cancel button">
          <i class="delete icon"></i> Close
        </div>
        <div class="ui icon positive button" @click="saveUser">
          <i class="checkmark icon"></i> Save User
        </div>
      </div>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import * as services from './../../services/'

  export default {
    data() {
      return {
        'users': [],
        'settings': {},
        'user': {},
        'userForDelete': null,
        'fetching': false,
        'moment': moment
      }
    },
    mounted() {
      this.fetchUsers()

      services.userService.on('created', () => {
        this.fetchUsers()
      })
      services.userService.on('patched', () => {
        this.fetchUsers()
      })
      services.userService.on('removed', () => {
        this.fetchUsers()
      })

      $('.huge.menu').visibility({
        type: 'fixed',
        offset: 0
      });
    },
    computed: {
      userRole() {
        return this.$store.state.user.data.role
      }
    },
    beforeDestroy() {
      $('.ui.modals').remove()
    },
    methods: {
      fetchUsers() {
        this.fetching = true

        services.userService.find().then(users => {
          this.users = users.data
          this.fetching = false
          this.initDropdown()
        })
      },
      initDropdown() {
        setTimeout(() => {
          $('.ui.dropdown').dropdown()
        }, 50)
      },
      triggerMenu() {
        $('.ui.sidebar').sidebar('toggle')
      },
      openReservationDetails(reservation) {
        console.log('open reservation')
        this.editReservation = reservation
        $('#reservationModal').modal({}).modal('show')
      },
      showUserModal() {
        $('#userModal').modal('show')
      },
      editUser(user) {
        this.user = user
        this.showUserModal()
      },
      addUser() {
        this.user = {
          email: null,
          password: null,
          name: null,
          role: null
        }
        this.showUserModal()
      },
      saveUser() {
        if (this.user._id) {
          services.userService.patch(this.user._id, this.user).then(user => {
            toastr.success('User saved!')
          }).catch(error => {
            toastr.error(error.message)
          })
        } else {
          services.userService.create(this.user).then(user => {
            toastr.success('User saved!')
          }).catch(error => {
            toastr.error(error.message)
          })
        }
      },
      triggerDeleteUser(user) {
        this.userForDelete = user

        $('.ui.delete.modal').modal('show')
      },
      deleteUser(user) {
        services.userService.remove(user._id).then(user => {
          toastr.info(`Removed user <strong>${user.name}</strong>`, 'User removed!')
        })
      }
    },
    components: {}
  }
</script>

<style scoped>
  .ui.calendar input {
    border: none;
    font-size: 1.3rem;
  }

  .red.item {
    color: #771d14;
  }

  .calendar.item {
    padding: 4px 1px 0;
  }

  .text.input input {
    border: none;
  }

  .text.input.item {
    padding: 10px;
  }

  .huge.menu.placeholder {
    height: 65px;
  }
</style>



// WEBPACK FOOTER //
// Users.vue?6cba2816